import styled, { css } from "styled-components";
import { graphicContainerIndex } from "../../../../config/zIndex";
import ReactTooltip from "react-tooltip";

export const GraphicContainer = styled.div`
  padding: 20px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;
  transition: all 0.5s ease-in-out;
  position: relative;
  @media (max-width: 910px) {
    width: 85%;
    padding: 10px;
  }
  @media (max-width: 490px) {
    ${({ maximizeGraphic }) =>
      maximizeGraphic &&
      css`
        width: 100%;
        height: 100vh;
        margin: 0;
        position: fixed;
        z-index: ${graphicContainerIndex};
        top: 0;
        bottom: 0;
      `}
  }
`;
export const GraphicRotateDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-in-out;
  @media (max-width: 490px) {
    ${({ maximizeGraphic }) =>
      maximizeGraphic &&
      css`
        width: 90vh;
        height: 90vw;
        z-index: ${graphicContainerIndex};
        transform: rotate(-90deg);
      `}
  }
`;
export const HeaderDiv = styled.div`
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
export const GraphicTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #000;
  text-align: center;
  @media (max-width: 910px) {
    font-size: 14px;
  }
  @media (max-width: 490px) {
    font-size: 12px;
  }
`;
export const ReactTooltipStyled = styled(ReactTooltip)`
  max-width: 500px;
  border-radius: 5px !important;
  padding: 15px !important;
`;
export const InfoButton = styled.button`
  margin-left: 10px;
  width: 20px;
  height: 20px;
  background: transparent;
  border: none;
  outline: none;
  position: relative;
`;
export const InfoImg = styled.img`
  width: 100%;
  height: 100%;
`;
export const BetaTitle = styled.p`
  font-size: 16px;
  color: #cdcdcd;
  position: absolute;
  right: 10px;
  @media (max-width: 910px) {
    font-size: 14px;
  }
  @media (max-width: 490px) {
    font-size: 12px;
  }
`;
export const MaximizeGraphicButton = styled.button`
  width: 20px;
  height: 20px;
  display: none;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  position: absolute;
  top: 22px;
  right: 20px;
  @media (max-width: 490px) {
    display: flex;
  }
`;
export const MaximizeGraphicImg = styled.img`
  width: 100%;
  height: 100%;
  transform: ${({ maximizeGraphic }) => maximizeGraphic && "rotate(90deg)"};
`;
export const AxisAndGraphicDiv = styled.div`
  width: 100%;
  height: ${({ height }) => (height ? height : "200px")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 910px) {
    height: 200px;
  }
`;
export const AxisYSizeDiv = styled.div`
  margin-left: 5px;
  width: 18px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
export const AxisY = styled.p`
  width: 200px;
  font-size: 14px;
  color: #666;
  text-align: center;
  transform: rotate(-90deg);
  position: absolute;
`;
export const GraphicSizeDiv = styled.div`
  width: 95%;
  height: 100%;
  @media (max-width: 800px) {
    width: 92%;
  }
  @media (max-width: 500px) {
    width: 88%;
  }
`;
export const AxisX = styled.p`
  margin-top: 10px;
  padding-left: 28px;
  width: 100%;
  font-size: 14px;
  color: #666;
  display: flex;
  justify-content: center;
`;
